import Link from "next/link";
import Text from "@ds/components/Text";
import HomeIcon from "@icons/Home";
import HomeSelectedIcon from "@icons/HomeSelected";
import {
  BillMobileSelected,
  ProductUnion,
  ProductUnionSelected,
  UserIconMobile,
  UserIconMobileSelected,
} from "@icons/mobile";
import BillingIcon from "@icons/BillingIcon";
import { Box } from "@mui/material";
import { ILinkMobile } from "./Layout.types";
import useStyles from "./styles";

export const MenuItem = ({ title, active, linkPage, icon }: ILinkMobile) => {
  const classes = useStyles({ active });

  return (
    <Link href={`${linkPage}`}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        style={{ margin: "0 auto", width: 56, height: 58, cursor: "pointer" }}
        className={classes.linkMenu}
      >
        {icon === "beranda" ? (
          <>{active ? <HomeSelectedIcon /> : <HomeIcon />}</>
        ) : icon === "produk" ? (
          <>{active ? <ProductUnionSelected /> : <ProductUnion />}</>
        ) : icon === "tagihan" ? (
          <>{active ? <BillMobileSelected /> : <BillingIcon />}</>
        ) : (
          <>{active ? <UserIconMobileSelected /> : <UserIconMobile />}</>
        )}
        <Text
          weight="400"
          variant="caption2"
          sx={{ fontSize: 10, lineHeight: "14px", color: active ? "#C72037" : "inherit" }}
        >
          {title}
        </Text>
      </Box>
    </Link>
  );
};

export default MenuItem;
